import { Injectable, Signal, computed } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BackgroundTileService {
  public backgroundUrl: Signal<string>;

  constructor(private layoutService: LayoutService) {
    this.backgroundUrl = computed(() => {
      const isDark = this.layoutService.isDarkTheme();
      return this.generateTiledBackground(isDark);
    });
  }

  private generateTiledBackground(isDarkMode: boolean): string {
    // Skip tiling for production environments
    const envName = environment.envName.toLowerCase();
    if (envName === 'prod' || envName === 'production') {
      return '';
    }

    // Create canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      console.error('Failed to get canvas context');
      return '';
    }

    // Set canvas size
    const tileSize = 400;
    canvas.width = tileSize;
    canvas.height = tileSize;

    // Get environment name (uppercase for consistency)
    const envNameDisplay = environment.envName.toUpperCase();

    // Set text color based on theme
    const textColor = isDarkMode
      ? 'rgba(255, 255, 255, 0.12)'  // 12% opacity for dark mode
      : 'rgba(0, 0, 0, 0.10)';        // 10% opacity for light mode

    // Configure text styling
    ctx.font = 'bold 100px monospace';
    ctx.fillStyle = textColor;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // Save context state
    ctx.save();

    // Move to center of canvas
    ctx.translate(tileSize / 2, tileSize / 2);

    // Rotate 45 degrees counter-clockwise
    ctx.rotate(-Math.PI / 4);

    // Draw the text at the rotated origin
    ctx.fillText(envNameDisplay, 0, 0);

    // Restore context state
    ctx.restore();

    // Convert canvas to data URL
    return canvas.toDataURL('image/png');
  }
}
